var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3544 0.562605C11.665 0.252058 12.1685 0.252058 12.479 0.562605C12.7896 0.873152 12.7896 1.37665 12.479 1.6872L2.80755 11.3587C2.49701 11.6692 1.99351 11.6692 1.68296 11.3587C1.37241 11.0481 1.37241 10.5446 1.68296 10.2341L11.3544 0.562605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.317 10.3129C12.6276 10.6234 12.6276 11.1269 12.317 11.4375C12.0065 11.748 11.503 11.748 11.1924 11.4375L1.52093 1.76599C1.21038 1.45544 1.21038 0.951945 1.52093 0.641397C1.83147 0.33085 2.33497 0.33085 2.64552 0.641397L12.317 10.3129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.36377C7.35134 5.36377 7.63616 5.64859 7.63616 5.99993C7.63616 6.35128 7.35134 6.6361 7 6.6361C6.64865 6.6361 6.36383 6.35128 6.36383 5.99993C6.36383 5.64859 6.64865 5.36377 7 5.36377Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuExit);
export default __webpack_public_path__ + "static/media/menu_exit.e267b013fddabb1df779344cf151373f.svg";
export { ForwardRef as ReactComponent };